import React from "react";
import Avatar from "@material-ui/core/Avatar";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import Tooltip from '@mui/material/Tooltip';
import Typography from "@mui/material/Typography";
import { useNavigate } from "react-router";
import { useDispatch } from "react-redux";

import { GetSpeakerFromConferenceAction } from "../../redux/action/SpeakerAction";

import { truncate } from "../../hooks/utils.js";
import video from "../../assets/icons/Icons/Label=Video.svg";
import podcast from "../../assets/icons/Icons/Label=Podcast.svg";
import article from "../../assets/icons/Icons/Label=Article.svg";

import "./MySpeaker.scss";

const VideoCard = ({
  item,
  type,
  publicationDate,
  index
}) => {
  let date;
  if (publicationDate) {
    date = new Date(publicationDate);
  } else if (item?.createdOn !== undefined) {
    date = new Date(item?.createdOn);
  } else if (item?.created) {
    date = new Date(item?.created);
  } else {
    date = new Date(item?.publicationDate);
  };
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const durationFNC = obj => {
    if (!obj) return "0";
    let timeTable = obj.substring(0, obj.indexOf(".") !== -1 ? obj.indexOf(".") : obj.length).split(":");
    let hh = timeTable[0];
    let mm = timeTable[1];
    let ss = timeTable[2];

    if (hh === "00") {
      return mm + ":" + ss;
    } else {
      return hh + ":" + mm + ":" + ss;
    }
  };

  const navigateToSpeakerPageAndRecordIt = () => {
    dispatch(GetSpeakerFromConferenceAction(window.location.pathname));
    navigate(`/speaker/${item?.speakers && item?.speakers[0]?.id}`);
  };

  const navigateToConferencePageAndRecordIt = () => {
    navigate(`/conference/${item?.catalogItemId}`);
  };

  return (
    (item !== undefined && item !== null && item?.speakers && item?.speakers[0]) &&
    <>
      <div className={"speakersBaseProfile"}>
        <Link to={`/conference/${item?.catalogItemId}`} className="container">
          <div className="row__top">
            <div className={type === "TopTcVideo" ? (index+1 <= 9 ? "row__top__poster_top-videos" : "row__top__poster_top-videos-double_digits") : "row__top__poster"} style={{
              backgroundImage: `url("${item.image}")`,
              backgroundRepeat: 'repeat',
              backgroundSize: 'cover',
              backgroundPosition: 'center'
            }}>
              <div className="row__top__poster_bottom">
                {<img src={(item.mediaTypeId || item.mediaType) === 1 ? video : ((item.mediaTypeId || item.mediaType) === 2 ? podcast : article)} />}
                <span className="row__top__poster_bottom_label">
                  {durationFNC(item.duration)}
                </span>
              </div>
            </div>
          </div>
        </Link>
        <div className="row__text">
          <div className="row__text__top">
            <div onClick={() => navigateToConferencePageAndRecordIt()} className="container" style={{
              display: 'flex',
              alignItems: 'flex-start',
              cursor: 'pointer'
            }}>
              <div className="row__text--label">{item?.name && item?.name.length > 33 ? `${item?.name.substring(0, 33)}...` : item?.name}</div>
            </div>                
          </div>
          <div style={{
            display: 'flex',
            alignItems: 'flex-start',
            cursor: 'pointer'
          }} onClick={() => navigateToSpeakerPageAndRecordIt()} className="row__text__top">
            <div className="row__text--label--speakername">
              <Avatar
                className="row__top--logo"
                src={item?.speakers ? item?.speakers[0]?.avatar : item?.avatar}
              />                
              <Tooltip title={(item?.speakers && item?.speakers[0]) ? item?.speakers[0]?.firstName : item?.firstName}>
                <Typography variant="h5">{(item?.speakers && item?.speakers[0] && item?.speakers[0]?.firstName) ? truncate(item?.speakers[0]?.firstName, 10) : ''}</Typography>
              </Tooltip>                
              <Tooltip title={(item?.speakers && item?.speakers[0] && item?.speakers[0]?.lastName) ? item?.speakers[0]?.lastName : item?.lastName}>
                <Typography variant="h5">{(item?.speakers && item?.speakers[0]) ? truncate(item?.speakers[0]?.lastName, 10) : ''}</Typography>
              </Tooltip>                
              {item?.speakersResponse ? item?.speakersResponse[0]?.firstName : item?.firstName} {item?.speakersResponse ? item?.speakersResponse[0]?.lastName : item?.lastName}
            </div>
          </div>
        </div>
      </div>      
    </>
  );
};

VideoCard.propTypes = {
  item: PropTypes.any.isRequired,
  userId: PropTypes.any,
  appearanceType: PropTypes.any,
  isSaved: PropTypes.any,
  ind: PropTypes.any,
};

export default VideoCard;
